import React from 'react';
import { Link } from 'gatsby';
import { SignUp, SignUpTitle } from './signUpBanner.styled';

const SignUpBanner = () => (
  <SignUp>
    <SignUpTitle>Sign Up for Our Newsletter</SignUpTitle>
    <Link to='http://eepurl.com/h935Pj' title='Sign up here' target='_blank' rel='noreferrer'>Sign Up Here</Link>
  </SignUp>
);

export default SignUpBanner;
